import { render, staticRenderFns } from "./CurrencyExchange.vue?vue&type=template&id=38445e4c&scoped=true&"
import script from "./CurrencyExchange.vue?vue&type=script&lang=js&"
export * from "./CurrencyExchange.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyExchange.vue?vue&type=style&index=0&id=38445e4c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38445e4c",
  null
  
)

export default component.exports